var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('svg',{staticClass:"rotate90",attrs:{"viewBox":"0 0 24 24"}},[_c('path',{attrs:{"d":"M19.78,11.78L18.36,13.19L12,6.83L5.64,13.19L4.22,11.78L12,4L19.78,11.78Z"}})])}
var staticRenderFns = []

export { render, staticRenderFns }